import { useContext, useEffect } from "react"
import { Button, ButtonGroup, Col, Form, InputGroup, Row } from "react-bootstrap"
import { FileEarmarkPdf, FiletypeCsv, Search } from "react-bootstrap-icons"
import { CSVLink } from "react-csv"


import { AlertaExpedicaoContext } from "../../pages/AlertaExpedicao/contextsAlerta/AlertaExpedicao"
import { CEPZERO } from "../../pages/AlertaExpedicao/utils/Constants"
import { AuthContext } from "../../store/AuthContext"

import "./index.css";
interface Props {
    filtro: string,
    /*setFiltro: (filtro: string) => void,*/
    lista: any[];
    keyTabLocal: string,
    numUnitizadorOuObjetoConsultar: any,
    setNumUnitizadorOuObjetoConsultar: (numUnitizadorConsultar: any) => void,
    placeholderCodSroUnitizadorObjeto: string,
    setFiltroInput: (event: React.ChangeEvent<HTMLInputElement>) => void,
    consultarCodSroOrigemOuUnitizadorOuObjeto: () => void,
    downloadAnaliticoPdf: (listaFiltrada: any[], usuario: any, filtro: string) => void,
    header_csv: any[],

    setCurrentPage: (currentPage: any) => void
};


const FiltrarExportar = ({
    filtro,
    lista,
    keyTabLocal,
    numUnitizadorOuObjetoConsultar,
    setNumUnitizadorOuObjetoConsultar,
    placeholderCodSroUnitizadorObjeto,
    setFiltroInput,
    consultarCodSroOrigemOuUnitizadorOuObjeto,
    downloadAnaliticoPdf,
    header_csv,
    setCurrentPage
}: Props) => {

    const { user } = useContext(AuthContext);

    const {
        dataSelecionada, setDataSelecionada,key
    } = useContext(AlertaExpedicaoContext)

    useEffect(() => {
        setDataSelecionada(()=>'1900-01-01');
        setNumUnitizadorOuObjetoConsultar(()=>'')
        return () => {
            setNumUnitizadorOuObjetoConsultar(()=>'')
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        setNumUnitizadorOuObjetoConsultar(()=>CEPZERO)
        setNumUnitizadorOuObjetoConsultar(()=>'')
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[key]);

    const setValorDataSelecionadaBtnConsultar = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        setCurrentPage(()=>0);
        consultarCodSroOrigemOuUnitizadorOuObjeto();
    }

    return (
        <>
            <Form className="border rounded p-1 mb-2">

                <Form.Group as={Row} controlId="formListaUnitizadorUnidadeData">

                    <Col sm={12} lg={4} xl={3}>
                        <Form.Control
                            className="h-100"
                            type="search"
                            placeholder="Filtrar"
                            title="Digite algo para filtrar."
                            disabled={!filtro && (!lista || lista.length === 0)}
                            value={filtro}
                            onChange={setFiltroInput}
                        />
                    </Col>
                    <Col sm={12} lg={8} xl={6}>
                                <Form.Group as={Row}>
                                    <Col sm={12}>
                                    <InputGroup>
                                        <Form.Control
                                            placeholder={placeholderCodSroUnitizadorObjeto ? placeholderCodSroUnitizadorObjeto : ''}
                                            title="Informe um Código SRO ou número Unitizador ou Objeto para consultar."
                                            type="search"
                                            aria-describedby="basic-addon2"
                                            value={numUnitizadorOuObjetoConsultar && numUnitizadorOuObjetoConsultar !== '00000000' ? numUnitizadorOuObjetoConsultar : ''}
                                            onChange={(e) => setNumUnitizadorOuObjetoConsultar(() => e.target.value)}
                                        />
                                        <Form.Control type="date"
                                            placeholder="Selecione data"
                                            title="Selecione uma data para consultar."
                                            aria-describedby="basic-addon2"
                                            value={dataSelecionada && dataSelecionada !== '1900-01-01' ? dataSelecionada : ''} onChange={(e) => setDataSelecionada(e.target.value)} 
                                        />
                                        <Button variant="primary" className="ps-1 py-0" id="button-addon2"
                                            title="Ao ser clicado consulta os unitizadores da data selecionada."
                                            onClick={(e) => setValorDataSelecionadaBtnConsultar(e)}>
                                            <Search className="icon-search" />
                                            Consultar
                                        </Button>

                                        </InputGroup>
                                    </Col>
                                </Form.Group>

                    </Col>
                    <Col sm={12} lg={12} xl={3}>
                        <ButtonGroup className='mb-2 w-100 h-100'>
                            {lista && lista.length > 0 ?
                                <CSVLink headers={header_csv} data={lista} separator={';'} filename={`analitico_${keyTabLocal}.csv`} className="btn btn-primary ps-1 pt-1 py-0" type="button"><FiletypeCsv color='white' size={24} /> CSV</CSVLink>
                                :
                                <Button variant="primary" className="ps-1 py-0" disabled={!lista || lista.length === 0}><FiletypeCsv color='white' size={24} /> CSV</Button>
                            }
                            <Button variant="primary" className="ps-1 py-0" disabled={!lista || lista.length === 0} onClick={() => downloadAnaliticoPdf(lista, user, filtro)}><FileEarmarkPdf color='red' size={24} /> PDF</Button>
                        </ButtonGroup>
                    </Col>
                </Form.Group>

            </Form>


        </>
    )
}

export default FiltrarExportar